import React from 'react'
import styled from 'styled-components'
import { LIGHTGRAY } from '../../../../../styles/colors.style'

const ModalTripPromotion = ({ promotionCoupon }) => {
	return (
		<React.Fragment>
			<StyledPromotion>
				{promotionCoupon && (
					<div className="panel">
						<div className="promotion-title">Promoção</div>
						<div className="itens">
							<span className="promotion">
								<span>Cupom Uber:</span>
							</span>
							<span className="promotion-code">
								<span>
									<a
										href={promotionCoupon.promotionUrl}
										className="orange underline"
										target="_blank">
										{promotionCoupon.code}
									</a>
								</span>
							</span>
						</div>
					</div>
				)}
			</StyledPromotion>
		</React.Fragment>
	)
}

const StyledPromotion = styled.div`
	.panel {
		border: 1px solid ${LIGHTGRAY};
		border-radius: 5px;
		padding: 10px;
		margin: 7px 0px;

		.promotion-title {
			font-size: 1.8rem;
			font-weight: bold;
		}

		.itens {
			display: flex;
			justify-content: space-between;
			margin: 4px 0px;

			.promotion {
				span:last-child {
					float: right;
				}
			}
			.promotion-code {
				font-weight: bold;
			}
		}
	}
`

export default ModalTripPromotion
